/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-common-alert-modal',
  templateUrl: './common-alert-modal.component.html',
  styleUrls: ['./common-alert-modal.component.scss']
})
export class CommonAlertModalComponent {

  @Input() title = ''
  @Input() message = ''
  @Input() cancelBtnTitle = ''
  @Input() actionBtnTitle = ''
  @Input()isModalOpen = false;
  @Input()actionType = '';
  @Input() placeholderObject : any;
  @Input() hideSecondaryBtn = '';
  @Output()
  isModalResponseClicked = new EventEmitter<any>();
  translationData: any;

  onCancel() {
    this.isModalResponseClicked.emit({action:false})
  }

  onAction() {
    this.isModalResponseClicked.emit({action:true, actionType:this.actionType})
  }


}
